// extracted by mini-css-extract-plugin
export default {"dropDownMenu":"hwOzl","dropdownContent":"Li6vW","avatarWrapper":"OtzxX","arrow":"qaKIm","avatar":"VHiOq","name":"XiILV"};